import { render, staticRenderFns } from "./RirekishoRequestsCard.vue?vue&type=template&id=a6e3d67a&scoped=true"
import script from "./RirekishoRequestsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RirekishoRequestsCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RirekishoRequestsCard.vue?vue&type=style&index=0&id=a6e3d67a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e3d67a",
  null
  
)

export default component.exports